export const ECustomerAccountSection = {
  FUNDING_SOURCES: "funding_sources",
} as const;

export type TCustomerAccountSection =
  (typeof ECustomerAccountSection)[keyof typeof ECustomerAccountSection];
